(function() {
    angular
        .module("app")
        .factory("messageBoardsService", messageBoardsService)

    messageBoardsService.$inject = [
        "$rootScope",
        "$http",
        "queryStringService"
    ]

    function messageBoardsService(
        $rootScope,
        $http,
        queryStringService
    ) {
        var service = {}
        var totalMessageBoardMessages = {}
        var messageSortOptions = [
            "favorite",
            "created_at",
            "name"
        ]
        var messageTypeOptions = [
            "custom",
            "permanent",
            "favorites"
        ]

        /**
            Get single message board
            @param {int}   messageBoardID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.getMessageBoard = function(messageBoardID, successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Create message board
            @param {obj}   formData
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.createMessageBoard = function(formData, ignoreDuplicate, successCallback, failureCallback) {

            formData = {
                ...formData,
                ignore_duplicate: ignoreDuplicate
            }

            var queryJson = queryStringService.createQueryJson(formData, "message_board")

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/",
                data: queryJson
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Edit existing message board description
            @param {int}   messageBoardID
            @param {obj}   formData
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.editMessageBoard = function(messageBoardID, formData, ignoreDuplicate, successCallback, failureCallback) {

            formData = {
                ...formData,
                ignore_duplicate: ignoreDuplicate
            }

            var queryJson = queryStringService.createQueryJson(formData, "message_board")

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID,
                data: queryJson
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error("Edit Message Board Failure: ", error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            @param {int}   messageBoardID
            @param {bool}  enable
            @param {func?} successCallback
            @param {func?} failureCallback

         **/
        service.setEnableAlerts = function(messageBoardID, enable, successCallback, failureCallback) {

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/enable_alerts",
                data: {
                    enable_alerts: enable
                }
            }).then(success, failure)
        }

        /**
            Edit message board auto refresh interval
            @param {int}   messageBoardID
            @param {int}   selectedTimeInterval
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.setRefreshTimeInterval = function(messageBoardID, selectedTimeInterval, successCallback, failureCallback) {

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/auto_refresh",
                data: {
                    interval_seconds: selectedTimeInterval
                }
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Blank message board display
            @param {int}   messageBoardID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.blankMessageBoardDisplay = function(messageBoardID, successCallback, failureCallback) {

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/blank"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Delete existing message board
            @param {int}   messageBoardID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.deleteMessageBoard = function(messageBoardID, successCallback, failureCallback) {

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error.data.errors[0])
                if (failureCallback !== undefined) {
                    failureCallback(error.data.errors[0])
                }
            }
        }

        /**
            Get message boards fonts
            @param {int}   messageBoardID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.getMessageBoardFonts = function(messageBoardID, successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/font_descriptions"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.getMessageNumbers = function(messageBoardID, successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/message_slots"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        // service.getAvailableMessageNumbers = function(messageBoardID, successCallback, failureCallback) {

        //     $http({
        //         method: "GET",
        //         url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/available_slots"
        //     }).then(success, failure)

        //     function success(response) {
        //         if (successCallback !== undefined) {
        //             successCallback(response.data)
        //         }
        //     }

        //     function failure(error) {
        //         console.error(error)
        //         if (failureCallback !== undefined) {
        //             failureCallback(error)
        //         }
        //     }
        // }

        /**
            Get message boards messages
            @param {int} messageBoardID
            @param page
            @param perPage
            @param sortBy
            @param sortDirection
            @param filterBy
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.getMessageBoardMessages = function(messageBoardID, page, perPage, sortBy, sortDirection, filterBy, successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/messages?"
                    + "sort=" + sortBy
                    + "&sort_direction=" + sortDirection
                    + "&page=" + page
                    + "&perpage=" + perPage
                    + "&filter=" + filterBy
            }).then(success, failure)

            function success(response) {
                totalMessageBoardMessages = response.headers("Total")
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Get message boards message count
            @returns {*}
         **/
        service.getTotalMessageBoardMessages = function() {
            return totalMessageBoardMessages
        }

        // /**
        //     Paginate message boards messages
        //     @param {int} messageBoardID
        //     @param page
        //     @param perPage
        //     @param {func?} successCallback
        //     @param {func?} failureCallback
        //  **/
        // service.getMessageBoardMessagesPaginated = function(messageBoardID, page, perPage) {
        //
        //     $http({
        //         method: "GET",
        //         url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/messages?page=" + page + "&perpage=" + perPage
        //     }).then(success, failure)
        //
        //     function success(response) {
        //         if (successCallback !== undefined) {
        //             successCallback(response.data)
        //         }
        //     }
        //
        //     function failure(error) {
        //         console.error(error)
        //         if (failureCallback !== undefined) {
        //             failureCallback(error)
        //         }
        //     }
        // }

        // /**
        //     Sort message boards messages
        //     @param {int} messageBoardID
        //     @param page
        //     @param perPage
        //     @param sortBy
        //     @param sortDirection
        //     @param filterBy
        //     @param {func?} successCallback
        //     @param {func?} failureCallback
        //  **/
        // service.sortMessageBoardMessages = function(messageBoardID, page, perPage, sortBy, sortDirection, filterBy, successCallback, failureCallback) {
        //
        //     if (messageSortOptions.indexOf(sortBy) < 0) {
        //         sortBy = "name"
        //     }
        //
        //     $http({
        //         method: "GET",
        //         url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/messages?"
        //             + "sort=" + sortBy
        //             + "&sort_direction=" + sortDirection
        //             + "&page=" + page
        //             + "&perpage=" + perPage
        //             + "&filter=" + filterBy
        //     }).then(success, failure)
        //
        //     function success(response) {
        //         if (successCallback !== undefined) {
        //             successCallback(response.data)
        //         }
        //     }
        //
        //     function failure(error) {
        //         console.error(error)
        //         if (failureCallback !== undefined) {
        //             failureCallback(error)
        //         }
        //     }
        // }

        /**
            Refresh message boards messages
            @param {int}    messageBoardID
            @param {string} messageType
            @param {func?}  successCallback
            @param {func?}  failureCallback
         **/
        service.refreshMessageBoardMessages = function(messageBoardID, messageType, successCallback, failureCallback) {
            if (messageTypeOptions.indexOf(messageType) < 0) {
                messageType = "custom"
            }
            var typeQuery = ""

            if(messageType) {
                typeQuery = "?type=" + messageType
            }

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/fetch_messages" + typeQuery
            }).then(success, failure)

            function success(response) {
                if (successCallback != undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error("Update Message Board Messages Error: ", error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Favorite message boards message
            @param {int}   messageBoardID
            @param {int}   messageID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.favoriteMessageBoardMessage = function(messageBoardID, messageID, successCallback, failureCallback) {

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/messages/" + messageID + "/favorite"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Unfavorite message boards message
            @param {int}   messageBoardID
            @param {int}   messageID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.unfavoriteMessageBoardMessage = function(messageBoardID, messageID, successCallback, failureCallback) {

            $http({
                method: "Delete",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/messages/" + messageID + "/favorite"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        return service
    }
})()
